import React from 'react';
import json from './dtiblock.js';
import DTICalculator from './DTICalculator.js';

var DTICalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$annualIncome = attrs.annualIncome,
      annualIncome = _attrs$annualIncome === void 0 ? 7000 : _attrs$annualIncome,
      _attrs$minCreditCardP = attrs.minCreditCardPayments,
      minCreditCardPayments = _attrs$minCreditCardP === void 0 ? 200 : _attrs$minCreditCardP,
      _attrs$carLoanPayment = attrs.carLoanPayments,
      carLoanPayments = _attrs$carLoanPayment === void 0 ? 50 : _attrs$carLoanPayment,
      _attrs$studentLoanPay = attrs.studentLoanPayments,
      studentLoanPayments = _attrs$studentLoanPay === void 0 ? 300 : _attrs$studentLoanPay,
      _attrs$alimonySupport = attrs.alimonySupportPayments,
      alimonySupportPayments = _attrs$alimonySupport === void 0 ? 0 : _attrs$alimonySupport,
      _attrs$secondaryHomeE = attrs.secondaryHomeExpenses,
      secondaryHomeExpenses = _attrs$secondaryHomeE === void 0 ? 0 : _attrs$secondaryHomeE,
      _attrs$otherDebtPayme = attrs.otherDebtPayments,
      otherDebtPayments = _attrs$otherDebtPayme === void 0 ? 0 : _attrs$otherDebtPayme;
    var defaultValues = {
      annualIncome: annualIncome,
      minCreditCardPayments: minCreditCardPayments,
      carLoanPayments: carLoanPayments,
      studentLoanPayments: studentLoanPayments,
      alimonySupportPayments: alimonySupportPayments,
      secondaryHomeExpenses: secondaryHomeExpenses,
      otherDebtPayments: otherDebtPayments
    };
    return /*#__PURE__*/React.createElement(DTICalculator, {
      defaultValues: defaultValues
    });
  },
  metadata: json
};
var DTICalculatorBlock$1 = DTICalculatorBlock;

export { DTICalculatorBlock$1 as default };
